export default function DSA_Memoization() {
  return <div>DSA_Memoization Component</div>;
}
